import Button from '@gogame/ui/Button';
import Toolbar from '@gogame/ui/Toolbar';
import Typography from '@gogame/ui/Typography';
import { withStyles } from '@gogame/ui/styles';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    marginRight: theme.spacing(2),
  },
  buttonLabel: {
    whiteSpace: 'nowrap',
  },
});

const LazyChartToolbar = ({ classes, onLoadChart }) => {
  return (
    <Toolbar className={classes.root} disableGutters={true}>
      <Typography className={classes.title}>
        Chart data loading will take a lot of time ( > 3 min), load anyway?
      </Typography>
      <Button
        variant={'outlined'}
        color={'primary'}
        onClick={onLoadChart}
        classes={{ label: classes.buttonLabel }}
      >
        Load chart
      </Button>
    </Toolbar>
  );
};

export default withStyles(styles, { name: 'LazyChartToolbar' })(
  LazyChartToolbar
);
